import React, { useState, useCallback } from "react";
import {
  Box,
  Button,
  Grid2 as Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
  InputAdornment,
  Chip,
} from "@mui/material";
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
} from "@mui/icons-material";
import { BossBabySearchParams } from "@/dto/BossBabyDto";

interface ToolFilterProps {
  searchTerm: string;
  category: string;
  isActive: boolean | "";
  sortBy: string;
  sortOrder: "asc" | "desc";
  onSearchTermChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onIsActiveChange: (value: boolean | "") => void;
  onSortByChange: (value: string) => void;
  onSortOrderChange: (value: "asc" | "desc") => void;
  onSearch: () => void;
  onReset: () => void;
}

export const ToolFilter: React.FC<ToolFilterProps> = ({
  searchTerm,
  category,
  isActive,
  sortBy,
  sortOrder,
  onSearchTermChange,
  onCategoryChange,
  onIsActiveChange,
  onSortByChange,
  onSortOrderChange,
  onSearch,
  onReset,
}) => {
  const hasActiveFilters =
    searchTerm ||
    category ||
    isActive !== "" ||
    sortBy !== "name" ||
    sortOrder !== "asc";

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <FilterIcon color="primary" />
        <Typography variant="h6">Search & Filter</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search tools..."
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            size="small"
            select
            label="Category"
            value={category}
            onChange={(e) => onCategoryChange(e.target.value)}
          >
            <MenuItem value="">All Categories</MenuItem>
            <MenuItem value="boss_baby">Boss Baby</MenuItem>
            <MenuItem value="utility">Utility</MenuItem>
            <MenuItem value="integration">Integration</MenuItem>
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            size="small"
            select
            label="Status"
            value={isActive}
            onChange={(e) =>
              onIsActiveChange(
                e.target.value === "" ? "" : e.target.value === "true"
              )
            }
          >
            <MenuItem value="">All Status</MenuItem>
            <MenuItem value="true">Active</MenuItem>
            <MenuItem value="false">Inactive</MenuItem>
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            size="small"
            select
            label="Sort By"
            value={sortBy}
            onChange={(e) => onSortByChange(e.target.value)}
          >
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="createdAt">Created Date</MenuItem>
            <MenuItem value="priority">Priority</MenuItem>
          </TextField>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            size="small"
            select
            label="Order"
            value={sortOrder}
            onChange={(e) =>
              onSortOrderChange(e.target.value as "asc" | "desc")
            }
          >
            <MenuItem value="asc">Ascending</MenuItem>
            <MenuItem value="desc">Descending</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="contained" onClick={onSearch}>
          Search
        </Button>
        <Button variant="outlined" onClick={onReset}>
          Reset
        </Button>
      </Box>

      {/* Active Filters */}
      {hasActiveFilters && (
        <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
          <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
            Active filters:
          </Typography>
          {searchTerm && (
            <Chip
              label={`Search: ${searchTerm}`}
              size="small"
              onDelete={() => onSearchTermChange("")}
            />
          )}
          {category && (
            <Chip
              label={`Category: ${category}`}
              size="small"
              onDelete={() => onCategoryChange("")}
            />
          )}
          {isActive !== "" && (
            <Chip
              label={`Status: ${isActive ? "Active" : "Inactive"}`}
              size="small"
              onDelete={() => onIsActiveChange("")}
            />
          )}
          {sortBy !== "name" && (
            <Chip
              label={`Sort: ${sortBy}`}
              size="small"
              onDelete={() => onSortByChange("name")}
            />
          )}
          {sortOrder !== "asc" && (
            <Chip
              label={`Order: ${sortOrder}`}
              size="small"
              onDelete={() => onSortOrderChange("asc")}
            />
          )}
        </Box>
      )}
    </Paper>
  );
};







